import { AssetSchema, AssetSignedUrlSchema } from "@storytell/types";
import { RequestBuilder } from "../requestBuilder";
import {
  AssetIdParamsSchema,
  CloneAssetRequestSchema,
  CreateAssetHttpInputSchema,
  CreateAssetHttpResponseSchema,
  GetAssetsRequestSchema,
  GetAssetsResponseSchema,
  IngestURLsRequestSchema,
  IngestURLsResponseSchema,
  MoveAssetsRequestSchema,
  SearchAssetsParamsSchema,
  SearchAssetsResponseSchema,
  UpdateAssetInputSchema,
  UploadCompleteParamsSchema,
} from "./assetClient.types";

export const DeleteAssetRequestConfig = new RequestBuilder({
  paramsSchema: AssetIdParamsSchema,
  path: (params) => `/assets/${params.id}`,
})
  .withMethod("DELETE")
  .withContentType(undefined)
  .withIncludeProjectId();

export const UpdateAssetRequestConfig = new RequestBuilder({
  paramsSchema: AssetIdParamsSchema,
  path: ({ id }) => `/assets/${id}`,
  responseSchema: AssetSchema,
  bodySchema: UpdateAssetInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

// HTTP API for file upload flow
export const CreateAssetHttpRequestConfig = new RequestBuilder({
  path: () => "/assets",
  responseSchema: CreateAssetHttpResponseSchema,
  bodySchema: CreateAssetHttpInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

export const UploadCompleteRequestConfig = new RequestBuilder({
  paramsSchema: UploadCompleteParamsSchema,
  path: (params) => `/assets/${params.assetId}/uploaded`,
  responseSchema: AssetSchema,
})
  .withMethod("PUT")
  .withIncludeProjectId();

export const GetAssetsRequestConfig = new RequestBuilder({
  path: () => "/assets/bulk",
  responseSchema: GetAssetsResponseSchema,
  bodySchema: GetAssetsRequestSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

export const GenerateSignedUrlRequestConfig = new RequestBuilder({
  paramsSchema: AssetIdParamsSchema,
  path: (params) => `/assets/${params.id}/download`,
  responseSchema: AssetSignedUrlSchema,
})
  .withMethod("GET")
  .withIncludeProjectId();

export const DownloadAssetRequestConfig = new RequestBuilder({
  paramsSchema: AssetIdParamsSchema,
  path: (params) => `/assets/${params.id}/download`,
  responseSchema: AssetSignedUrlSchema,
})
  .withMethod("GET")
  .withIncludeProjectId();

export const MoveAssetsRequestConfig = new RequestBuilder({
  path: () => "/assets-move",
  bodySchema: MoveAssetsRequestSchema,
})
  .withMethod("POST")
  .withContentType(undefined)
  .withIncludeProjectId();

export const CloneAssetRequestConfig = new RequestBuilder({
  paramsSchema: AssetIdParamsSchema,
  path: (params) => `/assets/${params.id}/clone`,
  bodySchema: CloneAssetRequestSchema,
  responseSchema: AssetSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

export const ReprocessAssetRequestConfig = new RequestBuilder({
  paramsSchema: AssetIdParamsSchema,
  path: (params) => `/assets/${params.id}/reprocess`,
  responseSchema: AssetSchema,
})
  .withMethod("POST")
  .withContentType(undefined)
  .withIncludeProjectId();

export const IngestURLsRequestConfig = new RequestBuilder({
  path: () => "/assets/ingest-urls",
  responseSchema: IngestURLsResponseSchema,
  bodySchema: IngestURLsRequestSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

export const SearchAssetsRequestConfig = new RequestBuilder({
  paramsSchema: SearchAssetsParamsSchema,
  responseSchema: SearchAssetsResponseSchema,
  path: () => "/assets/search",
})
  .withMethod("GET")
  .withContentType(undefined)
  .withQueryParams((params) => {
    if (!params) return undefined;
    const out: Record<string, string> = {};
    if (params.q !== undefined && params.q.length > 0) out.q = params.q;
    if (params.limit !== undefined) out.limit = String(params.limit);
    if (params.type !== undefined) out.type = params.type;
    if (params.owner !== undefined) out.owner = params.owner;
    if (params.status !== undefined) out.status = params.status;
    if (params.after !== undefined) out.after = params.after;
    if (params.before !== undefined) out.before = params.before;
    return out;
  })
  .withIncludeProjectId();
